export default (content: string, newWindow: Window) => {
  if (newWindow) newWindow.document.write(content);
};
